import React, { Component }  from 'react';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import { DefaultContainer } from "../components/Containers";

const Circles = () => {
  return (
    <>
      <Navbar />
      <Header title="Circles" />
      <DefaultContainer>
        TODO: Display circles list
      </DefaultContainer>
    </>
  );
};

export default Circles;